import wrapWithProvider from './wrap-with-provider';
import wrapWithLayout from './wrap-with-layout';

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = wrapWithLayout;
